import getRateLimit from './getRateLimit';
var NO_CONTENT = 204;
/**
* Parse JSON response. Check if there is x-ratelimit-reset header.
 *
 * @param  {Object} response - HTTP response
 * @return {Object} - parsed JSON
 */

export default function parseResponse(response) {
  if (response.status === NO_CONTENT) {
    return getRateLimit(response);
  }
  return response.json().catch(function () {});
}